import { render, staticRenderFns } from "./ProductCard.vue?vue&type=template&id=819031d8"
import script from "./ProductCard.vue?vue&type=script&lang=js"
export * from "./ProductCard.vue?vue&type=script&lang=js"
import style0 from "./ProductCard.vue?vue&type=style&index=0&id=819031d8&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('819031d8')) {
      api.createRecord('819031d8', component.options)
    } else {
      api.reload('819031d8', component.options)
    }
    module.hot.accept("./ProductCard.vue?vue&type=template&id=819031d8", function () {
      api.rerender('819031d8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/ProductCard.vue"
export default component.exports